import { render, staticRenderFns } from "./TrafficSourceCreate.vue?vue&type=template&id=76bfd2ee&scoped=true"
import script from "./TrafficSourceCreate.vue?vue&type=script&lang=js"
export * from "./TrafficSourceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bfd2ee",
  null
  
)

export default component.exports